import React, { useState } from "react";
import { Spin, Row, Col, notification, Form } from "antd";
import CropDown from "../../components/ReportFormGenerator/CropDown/CropDown";
import Button from "../../components/ReportFormGenerator/Button/Button";
 import StablePrime from "../../components/Tables/StablePrime";

function TrainingNeeds({ setPageHeader }) {
  const [form] = Form.useForm();
  const [FormData, setFormData] = useState(null);
  setPageHeader("Training Needs");

  const onFinish = (values) => {
    setFormData(values);
    
  };

  const productionTableStyle = {
    marginTop: "1rem",
    marginBottom: "1rem",
  };

  const Tables = () => {
    if (FormData) {
      return (
        <>
          {FormData ? (
            <div style={productionTableStyle}>
              <StablePrime
                url="/"
                data={FormData}
                identity="Training Needs"
              />
            </div>
          ) : (
            <></>
          )}
        </>
      );
    } else {
      return <></>;
    }
  };
  return (
    <>
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>
                <CropDown
                  name="yr"
                  label="Financial Year"
                  url="/cropdown"
                  urlData={{ name: "FinancialYear", includeAll: true }}
                  required={true}
                  errorMessage="Please Select Financial Year !"
                  placeholder="Select Finanacial Year"
                  searchable={true}
                />
              </Col>
            </Row>

            <Row gutter={24} justify="center">
              <Col span={24}>
                <Button
                  marginLeft={"300px"}
                  form={form}
                  cancelButtonText={"Cancel"}
                  submitButtonText={"Submit"}
                  resetButton={true}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <Tables />
    </>
  );
}

export default TrainingNeeds;
